export const TITLE_LIST = [
    {
        id: 'dr',
        value: 'Dr'
    }
];

export const MESSAGE_PLACEHOLDER = '%item%'

export const MANDATORY_FIELDS = [
    {
        id: 'firstName',
        value: 'Firstname'
    },
    {
        id: 'lastName',
        value: 'Lastname'
    },
    {
        id:'store',
        value:'Associated Clinic'
    },
];



// WEBPACK FOOTER //
// ./src/modules/partner/component/form/const.js